import { initContract } from "@ts-rest/core";
import { stripeCreateConnectionBodySchema } from "@common/schemas/domains/stripe/stripe-connection.schema";
import { integrationConnectionWithAccountsResponseSchema } from "@common/schemas/domains/integrationConnection/integration-connection-response.schema";

const c = initContract();

export const stripeContract = c.router(
    {
        createConnection: {
            method: "POST",
            path: "/",
            body: stripeCreateConnectionBodySchema,
            responses: {
                201: integrationConnectionWithAccountsResponseSchema,
            },
        },
    },
    {
        pathPrefix: "/stripe",
    },
);
